module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "game-list"
  }, _vm._l((_vm.games), function(game) {
    return _c('div', {
      staticClass: "game-list-row"
    }, [_c('router-link', {
      attrs: {
        "to": '/play/' + game.name
      }
    }, [_c('img', {
      staticClass: "gameicon",
      attrs: {
        "src": 'assets/gameicon/' + game.name + '_gameicon.png'
      }
    }), _vm._v(" "), _c('h3', {
      staticClass: "title"
    }, [_vm._v(_vm._s(game.title))]), _vm._v(" "), _c('div', {
      staticClass: "description"
    }, [_vm._v(_vm._s(game.description))])])], 1)
  }))
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7f7dca67","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/ListGames.vue
// module id = 31
// module chunks = 0